import { useEffect, useState } from 'react'
import { useHttpClient } from '../../../modules/services/Bundle'
import { RequestMethod } from '../../../modules/services/core/_enums'
import { GraficoMediaGeralPorParticipante } from './partials/GraficoMediaGeralPorParticipante'
import { IDadosGraficosPesquisaModel } from './helpers/AnaliseResultadoHelper'
import { ISelectModel } from '../../../modules/services/core/_models'
import { BotaoBaixarResultadoExcel } from './partials/BotaoBaixarResultadoExcel'

export interface ISelectPesquisaModel {
  Id: number              
  Nome: string 
  IdPesquisaParticipante: number
  Texto?: string
}

const ResultadoLiderados = () => {
  let [isMobile, setIsMobile] = useState(window.innerWidth < 992)
  let [pesquisas, setPesquisas] = useState<ISelectPesquisaModel[]>([])
  let [idPesquisa, setIdPesquisa] = useState<number>(0)
  let [dadosGraficosPesquisa, setDadosGraficosPesquisa] = useState<IDadosGraficosPesquisaModel | undefined>(undefined)
  const httpClient = useHttpClient()

  const obterParaSelectPesquisa = async () => {
    const response = await httpClient.request({
      method: RequestMethod.GET,
      endpoint: '/Pesquisa/Resultado/ObterParaSelectLiderados',
    })
    if (response.success && response.payload && response.payload.length > 0) {
      setPesquisas(response.payload)
    }
  }

  useEffect(() => {
    obterParaSelectPesquisa()
  },[])

  useEffect(() => {

    const onResizeWindow = () => {
      setIsMobile(window.innerWidth < 992)
    };

    window.addEventListener("resize", onResizeWindow);

    return () => window.removeEventListener("resize", onResizeWindow) 

  }, [])

  const onChangeSelectPesquisa = async (e: React.ChangeEvent<HTMLSelectElement>) => {
    setIdPesquisa(parseInt(e.target.value))  
  }

  const obterDadosGraficos = async () => {
    const response = await httpClient.request({
      method: RequestMethod.GET,
      endpoint: '/Pesquisa/Resultado/ObterParticipantesPesquisa',
      queryObject: {
        idPesquisa: idPesquisa
      }
    })

    if (response.success && response.payload) {
      setDadosGraficosPesquisa(response.payload)
    }
  }

  
  useEffect(() => {
    setDadosGraficosPesquisa(undefined)
    if(idPesquisa > 0) obterDadosGraficos()
    
  },[idPesquisa])

  return (
    <>
      <div className='card mb-6'>
        <div
          className='card-header'
        >
          <div className='card-title m-0'>
            <h3 className='fw-bolder m-0'>Análise de Dados - Liderados</h3>
          </div>
          <div className='card-toolbar'>
            <BotaoBaixarResultadoExcel
              endpoint='/Pesquisa/Resultado/ExportarResultadoLiderados'
              method={RequestMethod.GET}
              disabled={idPesquisa <= 0 || dadosGraficosPesquisa === undefined}
              queryObject={{idPesquisa}}
            />
          </div>
        </div>

        <div className='card-body py-5'>
            <div className='col-lg-6 fv-row'>
              <label className={`form-label text-gray-800`}>Selecione a pesquisa</label>
              <select
                className='form-select form-select-lg form-select-solid'
                onChange={(e: React.ChangeEvent<HTMLSelectElement>) => onChangeSelectPesquisa(e)}
              >
                <option value='0'>{'Selecione...'}</option>

                {pesquisas && pesquisas.length > 0
                  && pesquisas.map((data: ISelectModel, index: number) => {
                    return (
                      <option key={`select-pesquisa-${index}`} value={data.Id}>
                        {data.Nome}
                      </option>
                    )
                  })
                }
                
              </select>
            </div>
        </div>
      </div>
      {
        dadosGraficosPesquisa && (
          <GraficoMediaGeralPorParticipante
            isMobile={isMobile}
            dadosGraficosPesquisa={dadosGraficosPesquisa}
          />
        )
      }


    </>
  )
}

export {ResultadoLiderados}
